<template>
  <main :class="ns.b()">
    <slot />
  </main>
</template>
<script lang="ts" setup>
import { useNamespace } from '@lit-element/hooks'

defineOptions({
  name: 'LtMain',
})

const ns = useNamespace('main')
</script>
